export const MODAL_MANAGE_BULK_UPDATE = 'MODAL_MANAGE_BULK_UPDATE';
export const MODAL_MANAGE_BULK_UPDATE_CONFIRMATION =
  'MODAL_MANAGE_BULK_UPDATE_CONFIRMATION';
export const MODAL_RUN_USER_AGENT = 'modalRunAgent';
export const MODAL_RUN_CLOUD_AGENT = 'modalRunCloudAgent';
export const MODAL_UPGRADE_LICENSE = 'modalUpgradeLicense';
export const MODAL_UPGRADE_LICENSE_ACTION_BAR = 'modalUpgradeLicenseActionBar';
export const MODAL_AGENT_TOKEN = 'modalAgentToken';
export const MODAL_AGENT_CREATE = 'modalAgentCreate';
export const MODAL_CLOUD_AGENT_CREATE = 'modalCloudAgentCreate';
export const MODAL_SCHEDULE_CREATE_EDIT = 'modalScheduleCreateEdit';
export const MODAL_WORKSPACE_CREATE_EDIT = 'modalWorkspaceCreateEdit';
export const MODAL_WORKSPACE_CREATE = 'modalWorkspaceCreate';
export const MODAL_EVIDENCE = 'MODAL_EVIDENCE';
export const MODAL_JIRA = 'MODAL_JIRA';
export const MODAL_JIRA_TEMPLATE = 'MODAL_JIRA_TEMPLATE';
export const MODAL_NEW_JIRA_TEMPLATE = 'MODAL_NEW_JIRA_TEMPLATE';
export const MODAL_SEND_TO_JIRA = 'MODAL_SEND_TO_JIRA';
export const MODAL_RUN_PIPELINE = 'modalRunPipeline';
export const MODAL_SAVE_JOB = 'modalSaveJob';
export const MODAL_CREATE_SERVICE = 'MODAL_CREATE_SERVICE';
export const MODAL_ANALYTICS_CONFIRM_NAVIGATION =
  'MODAL_ANALYTICS_CONFIRM_NAVIGATION';
export const MODAL_ANALYTICS_CONFIRM_DELETE = 'MODAL_ANALYTICS_CONFIRM_DELETE';
export const MODAL_ANALYTICS_NOTIFICATION_MESSAGE =
  'MODAL_ANALYTICS_NOTIFICATION_MESSAGE';
export const MODAL_PROJECTS_CREATE_EDIT = 'MODAL_PROJECTS_CREATE_EDIT';
export const MODAL_PROJECTS_DELETE = 'MODAL_PROJECTS_DELETE';
export const MODAL_PROJECTS_SHOW_ERROR = 'MODAL_PROJECTS_SHOW_ERROR';
export const MODAL_TASKS_CREATE_EDIT = 'MODAL_TASKS_CREATE_EDIT';
export const MODAL_TASKS_DELETE = 'MODAL_TASKS_DELETE';
export const MODAL_TASKS_REDIRECT_TO_MANAGE = 'MODAL_TASKS_REDIRECT_TO_MANAGE';
export const MODAL_TASKS_COMMENT_DELETE = 'MODAL_TASKS_COMMENT_DELETE';
export const MODAL_REDIRECT_CONFIRMATION = 'MODAL_REDIRECT_CONFIRMATION';
export const MODAL_SCHEDULER_NO_WS_WARNING = 'MODAL_SCHEDULER_NO_WS_WARNING';
export const MODAL_APPLY_TEMPLATE = 'MODAL_APPLY_TEMPLATE';
export const MODAL_CUSTOM_ATTRIBUTES = 'MODAL_CUSTOM_ATTRIBUTES';
export const MODAL_SCHEDULER_OFFLINE_AGENT_WARNING =
  'MODAL_SCHEDULER_OFFLINE_AGENT_WARNING';
export const MODAL_JOBS_DELETE = 'MODAL_JOBS_DELETE';
export const MODAL_UPGRADE_LICENSE_SIDEBAR = 'modalUpgradeLicenseSidebar';
export const MODAL_CLOUD_ONLY_SCANNERS = 'modalCloudOnlyScanners';
export const MODAL_TOUR_FINISHED = 'MODAL_TOUR_FINISHED';
export const MODAL_REPORTS_SELECT_TEMPLATE = 'MODAL_REPORTS_SELECT_TEMPLATE';
export const MODAL_REPORT_WARNING_LOGO = 'MODAL_REPORT_WARNING_LOGO';
export const MODAL_EVIDENCE_WARNING_UPLOAD = 'MODAL_EVIDENCE_WARNING_UPLOAD';
export const MODAL_VULNS_NOT_CONFIRMED = 'MODAL_VULNS_NOT_CONFIRMED';
export const MODAL_SEND_TO_SERVICENOW = 'MODAL_SEND_TO_SERVICENOW';
export const MODAL_SEND_TO_GITLAB = 'MODAL_SEND_TO_GITLAB';
export const MODAL_SEND_TO_WHD = 'MODAL_SEND_TO_WHD';
export const MODAL_UPGRADE_LICENSE_NOTIFICATION =
  'modalUpgradeLicenseNotification';
export const MODAL_MOVE_VULN_HOST = 'MODAL_MOVE_VULN_HOST';
export const MODAL_CANT_CREATE = 'MODAL_CANT_CREATE';
export const MODAL_USER_TOKEN_ACTION = ' MODAL_USER_TOKEN_ACTION';
export const MODAL_MOVE_ASSET_WS = 'MODAL_MOVE_ASSET_WS';
export const MODAL_SERVICE_DESK_BASIC_SETUP = 'MODAL_SERVICE_DESK_BASIC_SETUP';
export const MODAL_SERVICE_DESK_CONFIGURE_TEMPLATE = 'MODAL_SERVICE_DESK_CONFIGURE_TEMPLATE';
export const MODAL_SCHEDULE_DELETE = 'modalScheduleDelete';
export const MODAL_USERS_ASSIGN_WS = 'MODAL_USERS_ASSIGN_WS';
export const MODAL_AGENT_DETAIL = 'MODAL_AGENT_DETAIL';
export const MODAL_AGENT_TRIGGER_WARNING = 'MODAL_AGENT_TRIGGER_WARNING';
export const MODAL_TAGS_IN_AGENTS = 'MODAL_TAGS_IN_AGENTS';
export const MODAL_SCHEDULE_DETAIL = 'MODAL_SCHEDULE_DETAIL';
export const MODAL_AGENT_EXECUTOR_DETAIL = 'MODAL_AGENT_EXECUTOR_DETAIL';
export const MODAL_WORKSPACE_UPDATE_NAME = 'modalWorkspaceUpdateName';
export const MODAL_SEND_TO_SERVICE_DESK = 'MODAL_SEND_TO_SERVICE_DESK';
export const MODAL_SCHEDULER_INACTIVE_WARNING = 'MODAL_SCHEDULER_INACTIVE_WARNING';
export const MODAL_CONFIGURATION_BIDIRECTIONALITY = 'MODAL_CONFIGURATION_BIDIRECTIONALITY';
export const MODAL_ROLE_CREATE_EDIT = 'MODAL_ROLE_CREATE_EDIT';
export const MODAL_ROLE_DETAIL = 'MODAL_ROLE_DETAIL';
export const MODAL_ROLES_DELETE_CONFIRMATION = 'MODAL_ROLES_DELETE_CONFIRMATION';
export const MODAL_AUTHORIZE_CONFIRMATION = 'MODAL_AUTHORIZE_CONFIRMATION';
export const MODAL_UPLOAD_STYLING_TEMPLATE = 'MODAL_UPLOAD_STYLING_TEMPLATE';
export const MODAL_WORKSPACE_GROUPING_CONFIRM = 'MODAL_WORKSPACE_GROUPING_CONFIRM';
export const MODAL_VULNS_CREATE_MANUAL_GROUPING = 'MODAL_VULNS_CREATE_MANUAL_GROUPING';
export const MODAL_VULNS_ADD_TO_MANUAL_GROUPING = 'MODAL_VULNS_ADD_TO_MANUAL_GROUPING';
export const MODAL_EMAIL_VERIFICATION = 'MODAL_EMAIL_VERIFICATION';
export const MODAL_EMAIL_VERIFICATION_MESSAGE = 'MODAL_EMAIL_VERIFICATION_MESSAGE';
export const MODAL_SET_REPORT_TEMPLATE_NAME = 'MODAL_SET_REPORT_TEMPLATE_NAME';
export const MODAL_UPLOAD_DATA_TEMPLATE = 'MODAL_UPLOAD_DATA_TEMPLATE';
// community/dev only: professional/dev removed this once Security Scanners became a
// real feature there, but community/dev still shows the locked teaser (see
// Screens/Automation/Agents/index.jsx and components/Tabs/index.jsx, both two-versions-
// per-branch files per the migration plan Caso C).
export const MODAL_UPGRADE_LICENSE_CLOUD_AGENTS = 'modalUpgradeLicenseCloudAgent';
export const MODAL_UPGRADE_LICENSE_QUICK_PLANNER = 'MODAL_UPGRADE_LICENSE_QUICK_PLANNER';
export const MODAL_UPGRADE_LICENSE_MANUAL_GROUPING = 'MODAL_UPGRADE_LICENSE_MANUAL_GROUPING';
export const MODAL_UPGRADE_LICENSE_SETTINGS_REPORT = 'MODAL_UPGRADE_LICENSE_SETTINGS_REPORT';
export const MODAL_UPGRADE_LICENSE_SETTINGS_NOTIFICATIONS = 'MODAL_UPGRADE_LICENSE_SETTINGS_NOTIFICATIONS';
